<template>
    <div>
        <div class="mt-12">
            <h3 class="font-semibold text-base mb-4">{{ $t('apps.configurator.styles.settings') }}</h3>
            <div class="flex flex-col vx-card p-8 w-96">
                <div>
                    <LabelForm margins="mb-1" font-size="text-sm">{{ $t('apps.configurator.manage-item.name') }}</LabelForm>
                    <vs-input class="border-grey-light w-full"
                              type="text"
                              v-model="style.name"
                              :danger="style.name == ''"
                    />
                </div>

                <div>
                    <LabelForm margins="mt-5 mb-1" font-size="text-sm">{{ $t('admin.interactive-maps.timeofyear') }}</LabelForm>
                    <Combobox
                        v-model="style.timeOfYear"
                        :options="['winter', 'summer', 'always'].map(timeofyear => ({key: timeofyear, text: $t(`admin.interactive-maps.timeofyear-${timeofyear}`)}))"
                    />
                </div>

                <div>
                    <LabelForm margins="mt-5 mb-1" font-size="text-sm">{{ $t('apps.configurator.manage-item.type') }}</LabelForm>
                    <Combobox
                        v-model="style.styles_template_uuid"
                        :disabled="!isAdminUser || !this.new"
                        :options="styleTemplates.map(template => ({key: template.uuid, text: template.name}))"
                        @input="changeTemplate"
                    />
                </div>
            </div>
        </div>

        <div class="mt-12" v-if="style.styles_template_uuid">
            <h3 class="font-semibold text-base mb-4">{{ $t('apps.configurator.styles.definitions') }}</h3>
            <div class="flex flex-col vx-card p-8">
                <DynamicForm
                    :is-read-only="!isAdminUser"
                    v-model="dynamicFormData"
                    @input="editData"
                    @check-validation="setDynamicFormValidity"
                />
            </div>
        </div>

        <div class="flex items-center ml-0 gap-4 mt-8">
            <vs-button :disabled="!isValid || !isAdminUser" class="rounded-lg xs:w-full sm:w-auto" @click="save">
                {{ $t('resorts.touristic-objects.form.saveButton') }}
            </vs-button>
            <vs-button type="border" class="rounded-lg xs:w-full sm:w-auto text-primary" @click="goToStylesListPage">
                {{ $t('resorts.touristic-objects.form.cancelButton') }}
            </vs-button>
        </div>
    </div>
</template>

<script>

import store from "@/modules/Shared/Store/store";
import loader from "@/modules/Shared/Mixins/loader";
import ConfiguratorStylesService from '@/modules/Apps/Services/Configurator/ConfiguratorStylesService'
import LabelForm from "@/modules/Shared/Components/form/LabelForm.vue";
import ConfiguratorVersionService from "@/modules/Apps/Services/Configurator/ConfiguratorVersionService";
import {userHasAdminRole} from "@/modules/Auth/Helpers/permissionsHelper";
import Combobox from "@/modules/Shared/Components/Combobox.vue";
import DynamicForm from "@/modules/Shared/Components/form/DynamicForm.vue";

export default {
    name: "EditMapboxAccountPage",
    components: {DynamicForm, Combobox, LabelForm},
    mixins: [loader],
    data() {
        return {
            styleTemplates: [],
            style: {
                uuid: '',
                version_uuid: '',
                timeOfYear: 'winter',
                styles_template_uuid: '',
                values: {},
            },
            new: true,
            isDinamicFormValid: true
        }
    },

    computed: {
        isValid() {
            return this.style.name &&
                this.style.styles_template_uuid &&
                this.isDinamicFormValid
        },
        isAdminUser() {
            return userHasAdminRole()
        },
        dynamicFormData() {
            return {
                template: this.styleTemplates.find(template => template.uuid === this.style.styles_template_uuid).form,
                values: this.style.values
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        const [version, styleTemplatesResponse] = await Promise.all([
            ConfiguratorVersionService.getVersion(to.params.versionUuid),
            ConfiguratorStylesService.getTemplateList()
        ])

        const styleTemplates = styleTemplatesResponse.data;

        try {
            const style = await ConfiguratorStylesService.getStyle(to.params.styleUuid);

            await store.dispatch('setRouteElement', {...style, version})
            next(vm => {
                vm.styleTemplates = styleTemplates
                vm.style = {...style, version_uuid: version.uuid}
                vm.new = false
            })
        } catch (error) {
            await store.dispatch('setRouteElement', {version})
            next(vm => {
                vm.styleTemplates = styleTemplates
                vm.style = {
                    uuid: to.params.styleUuid,
                    version_uuid: version.uuid,
                    timeOfYear: "winter",
                    styles_template_uuid: '',
                    values: {}
                }
            })
        }
    },
    methods: {
        setDynamicFormValidity(isValid) {
            this.isDinamicFormValid = isValid
        },
        changeTemplate(templateUuid) {
            this.style.values = {}

            this.styleTemplates.find(template => template.uuid === templateUuid).form.forEach(element => {
                if (element.input === "checkbox") {
                    this.style.values[element.key] = false
                } else if (element.input === "color") {
                    this.style.values[element.key] = "#00000000"
                } else {
                    this.style.values[element.key] = ""
                }
            })
        },
        editData(data) {
            this.style.values = data.values
        },
        save() {
            this.loadAndNotify(async () => {
                if (this.new) {
                    await ConfiguratorStylesService.createStyle(this.style);
                } else {
                    await ConfiguratorStylesService.editStyle(this.style);
                }

                await this.goToStylesListPage()
            })
        },
        async goToStylesListPage() {
            await this.$router.push({
                name: 'styles',
                params: {
                    uuid: this.$route.params.uuid,
                    versionUuid: this.$route.params.versionUuid,
                }
            })
        }
    }
};
</script>
